export const TOGGLE_ROLES_IN_BULK_START =
  'TOGGLE_ROLES_IN_BULK_START';
export const TOGGLE_ROLES_IN_BULK_SUCCESS =
  'TOGGLE_ROLES_IN_BULK_SUCCESS';
export const TOGGLE_ROLES_IN_BULK_FAILURE =
  'TOGGLE_ROLES_IN_BULK_FAILURE';
